import {
  createSlice,
  PayloadAction,
  Slice,
  CaseReducerActions,
  SliceCaseReducers,
  AnyAction,
} from "@reduxjs/toolkit";
import { Reducer } from "react";
import { RootState, AppThunk } from ".";
import { FollowupService, IFollowupService } from "../services/proyecta/followup.service";
import { Utilities, Dictionary, IDictionary, LocalStorageHelper, Enums } from "@utils";
import { IFollowup } from "@models/";

export interface IFollowState {
  formMasters: any;
  followupData: IFollowup[];
  subProjectDimensions: any[];
  subProjectMonths: any[];
  subProjectPeriods: any[];
  labels: IDictionary<string, string>;
  indicatorsData: any;
  beneficiariesData: any;
  financialData: any;
  resultsFramework: any;
  institutionalIndicators: any;
  narrativeReport: any;
  infoByProject: any;
  infoByCountry: any;
  stepData: any;
  seenAppTourInd: boolean;
  seenAppTourBen: boolean;
  seenAppTourFin: boolean;
  seenAppTourIN: boolean;
  stepTourInd: number;
  stepTourBen: number;
  stepTourFin: number;
  stepTourIN: number;
  migrationData: any;
}
  
export class FollowupStore {
  reducer: Reducer<any, AnyAction>;
  service: IFollowupService;
  initialState: IFollowState;
  initialDeatailState: any;
  slice: Slice;
  actions: CaseReducerActions<SliceCaseReducers<any>>;

  selectFormMasters: any;
  selectFollowupData: any;
  selectSubProjectDimensions: any;
  selectSubProjectMonths: any;
  selectSubProjectPeriods: any;
  selectLabels: any;
  selectIndicatorsData: any;
  selectBeneficiariesData: any;
  selectFinancialData: any;
  selectResultsFramework: any
  selectInstitutionalIndicators: any;
  selectNarrativeReport: any;
  selectInfoByProject: any;
  selectInfoByCountry: any;
  selectStepData: any;
  selectSeenAppTourInd: any;
  selectSeenAppTourBen: any;
  selectSeenAppTourFin: any;
  selectSeenAppTourIN: any;
  selectStepTourInd: any;
  selectStepTourBen: any;
  selectStepTourFin: any;
  selectStepTourIN: any;
  selectMigrationData: any;

  constructor() {
    this.followup();
  }

  private followup() {
    this.service = new FollowupService();
    this.initialState = this.stateInit();
    this.slice = createSlice({
      name: "followup",
      initialState: this.initialState,
      reducers: this.reducersInit(),
    });

    this.actions = this.slice.actions;
    this.reducer = this.slice.reducer;

    this.selectorsInit();
  }

  private reducersInit() {
    return {
      setAllFormMasters: (state: IFollowState, action: PayloadAction<any>) => {
        state.formMasters = action.payload;
      },
      setFollowupData: (state: IFollowState, action: PayloadAction<any>) => {
        state.followupData = action.payload;
      },
      setSubProjectDimensions: (state: IFollowState, action: PayloadAction<any>) => {
        state.subProjectDimensions = action.payload;
      },
      setSubProjectMonths: (state: IFollowState, action: PayloadAction<any>) => {
        state.subProjectMonths = action.payload;
      },
      setSubProjectPeriods: (state: IFollowState, action: PayloadAction<any>) => {
        state.subProjectPeriods = action.payload;
      },
      setLabels: (state: IFollowState, action: PayloadAction<any>) => {
        state.labels = action.payload;
      },
      setAllIndicatorsData: (state: IFollowState, action: PayloadAction<any>) => {
        state.indicatorsData = action.payload;
      },
      setAllBeneficiariesData: (state: IFollowState, action: PayloadAction<any>) => {
        state.beneficiariesData = action.payload;
      },
      setAllFinancialData: (state: IFollowState, action: PayloadAction<any>) => {
        state.financialData = action.payload;
      },
      setAllResultsFramework: (state: IFollowState, action: PayloadAction<any>) => {
        state.resultsFramework = action.payload;
      },
      setInstitutionalIndicators: (state: IFollowState, action: PayloadAction<any>) => {
        state.institutionalIndicators = action.payload;
      },
      setNarrativeReport: (state: IFollowState, action: PayloadAction<any>) => {
        state.narrativeReport = action.payload;
      },
      setInfoByProject: (state: IFollowState, action: PayloadAction<any>) => {
        state.infoByProject = action.payload;
      },
      setInfoByCountry: (state: IFollowState, action: PayloadAction<any>) => {
        state.infoByCountry = action.payload;
      },
      setStepData: (state: IFollowState, action: PayloadAction<any>) => {
        state.stepData = action.payload;
      },
      setSeenAppTourInd: (state: IFollowState, action: PayloadAction<any>) => {
        state.seenAppTourInd = action.payload;
      },
      setSeenAppTourBen: (state: IFollowState, action: PayloadAction<any>) => {
        state.seenAppTourBen = action.payload;
      },
      setSeenAppTourFin: (state: IFollowState, action: PayloadAction<any>) => {
        state.seenAppTourFin = action.payload;
      },
      setSeenAppTourIN: (state: IFollowState, action: PayloadAction<any>) => {
        state.seenAppTourIN = action.payload;
      },
      setStepTourInd: (state: IFollowState, action: PayloadAction<any>) => {
        state.stepTourInd = action.payload;
      },
      setStepTourBen: (state: IFollowState, action: PayloadAction<any>) => {
        state.stepTourBen = action.payload;
      },
      setStepTourFin: (state: IFollowState, action: PayloadAction<any>) => {
        state.stepTourFin = action.payload;
      },
      setStepTourIN: (state: IFollowState, action: PayloadAction<any>) => {
        state.stepTourIN = action.payload;
      },
      setMigrationData: (state: IFollowState, action: PayloadAction<any>) => {
        state.migrationData = action.payload;
      },
    };
  }

  private selectorsInit() {
    this.selectFormMasters = (state: RootState) => state.followup.formMasters;
    this.selectFollowupData = (state: RootState) => state.followup.followupData;
    this.selectSubProjectDimensions = (state: RootState) => state.followup.subProjectDimensions;
    this.selectSubProjectMonths = (state: RootState) => state.followup.subProjectMonths;
    this.selectSubProjectPeriods = (state: RootState) => state.followup.subProjectPeriods;
    this.selectLabels = (state: RootState) => state.followup.labels;
    this.selectIndicatorsData = (state: RootState) => state.followup.indicatorsData;
    this.selectBeneficiariesData = (state: RootState) => state.followup.beneficiariesData;
    this.selectFinancialData = (state: RootState) => state.followup.financialData;
    this.selectResultsFramework = (state: RootState) => state.followup.resultsFramework;
    this.selectInstitutionalIndicators = (state: RootState) => state.followup.institutionalIndicators;
    this.selectNarrativeReport = (state: RootState) => state.followup.narrativeReport;
    this.selectInfoByProject = (state: RootState) => state.followup.infoByProject;
    this.selectInfoByCountry = (state: RootState) => state.followup.infoByCountry;
    this.selectStepData = (state: RootState) => state.followup.stepData;
    this.selectSeenAppTourInd = (state: RootState) => state.followup.seenAppTourInd;
    this.selectSeenAppTourBen = (state: RootState) => state.followup.seenAppTourBen;
    this.selectSeenAppTourFin = (state: RootState) => state.followup.seenAppTourFin;
    this.selectSeenAppTourIN = (state: RootState) => state.followup.seenAppTourIN;
    this.selectStepTourInd = (state: RootState) => state.followup.stepTourInd;
    this.selectStepTourBen = (state: RootState) => state.followup.stepTourBen;
    this.selectStepTourFin = (state: RootState) => state.followup.stepTourFin;
    this.selectStepTourIN = (state: RootState) => state.followup.stepTourIN;
    this.selectMigrationData = (state: RootState) => state.followup.migrationData;
  }

  private stateInit() {
    let state: IFollowState = {
      formMasters: null,
      followupData: [],
      subProjectDimensions: [],
      subProjectMonths: [],
      subProjectPeriods: [],
      labels: new Dictionary<string, string>(),
      indicatorsData: null,
      beneficiariesData: null,
      financialData: null,
      resultsFramework: null,
      institutionalIndicators: null,
      narrativeReport: null,
      infoByProject: null,
      infoByCountry: null,
      stepData: null,
      seenAppTourInd: LocalStorageHelper.get<boolean>(Enums.LocalStorageKeys.seenAppTourInd) || false,
      seenAppTourBen: LocalStorageHelper.get<boolean>(Enums.LocalStorageKeys.seenAppTourBen) || false,
      seenAppTourFin: LocalStorageHelper.get<boolean>(Enums.LocalStorageKeys.seenAppTourFin) || false,
      seenAppTourIN: LocalStorageHelper.get<boolean>(Enums.LocalStorageKeys.seenAppTourIN) || false,
      stepTourInd: 1,
      stepTourBen: 1,
      stepTourFin: 1,
      stepTourIN: 1,
      migrationData: null
    };
    return state;
  }

  public getOnlyFollowupData = (): AppThunk => (dispatch, getState) => {
    this.service.getOnlyFollowupData()
      .then((followupData: any) => {
        dispatch(this.actions.setFollowupData(followupData));
      })
      .catch((err) => {
        Utilities.writeInConsoleLog(err);
      });
  };

  public getFollowupData = (clear?: boolean): AppThunk => (dispatch, getState) => {
    if(clear){
        dispatch(this.actions.setFollowupData([]));
        dispatch(this.actions.setSubProjectDimensions([]));
        dispatch(this.actions.setSubProjectMonths([]));
        dispatch(this.actions.setSubProjectPeriods([]));
    }else{
      this.service.getFollowupData()
        .then(({followupData, subProjectDimensions, subProjectMonths, subProjectPeriods}: any) => {
          dispatch(this.actions.setFollowupData(followupData));
          dispatch(this.actions.setSubProjectDimensions(subProjectDimensions));
          dispatch(this.actions.setSubProjectMonths(subProjectMonths));
          dispatch(this.actions.setSubProjectPeriods(subProjectPeriods));
        })
        .catch((err) => {
          Utilities.writeInConsoleLog(err);
        });
    }
  };

  public getAllFormMasters = (): AppThunk => (dispatch, getState) => {
    const lang = getState().session.lang;
    if (!Utilities.isNullObject(lang)) {
      this.service
        .getAllFormMasters(lang.label)
        .then((formMaster: any) => {
          dispatch(this.actions.setAllFormMasters(formMaster));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }
  };

  public getLabels = (): AppThunk => (dispatch, getState) => {
    const lang = getState().session.lang;
    if (!Utilities.isNullObject(lang)) {
      this.service
        .getLabels(lang.label)
        .then((labels: Dictionary<string, string>) => {
          dispatch(this.actions.setLabels(labels));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }
  };

  public getIndicatorsData = (followupId: string): AppThunk => (dispatch, getState) => {
    if(followupId){
      this.service
      .getIndicatorsData(followupId)
      .then((indData: any) => {
        dispatch(this.actions.setAllIndicatorsData(indData));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setAllIndicatorsData(null));
  };

  public getBeneficiariesData = (followupId: string): AppThunk => (dispatch, getState) => {
    if(followupId){
      this.service
        .getBeneficiariesData(followupId)
        .then((indData: any) => {
          dispatch(this.actions.setAllBeneficiariesData(indData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setAllBeneficiariesData(null));
  };

  public getFinancialData = (followupId: string): AppThunk => (dispatch, getState) => {
    if(followupId){
      this.service
        .getFinancialData(followupId)
        .then((indData: any) => {
          dispatch(this.actions.setAllFinancialData(indData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setAllFinancialData(null));
  };

  public getResultsFramework = (followupId: string, subvCode?: string): AppThunk => (dispatch, getState) => {
    if(followupId){
      this.service
      .getResultsFramework(followupId, subvCode)
      .then((indData: any) => {
        dispatch(this.actions.setAllResultsFramework(indData || []));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setAllResultsFramework(null));
  };

  public getSPFE = (followupId: string, subvCode?: string): AppThunk => (dispatch, getState) => {
   if(followupId){
      this.service
      .getSPFE(followupId, subvCode)
      .then((stepData: any) => {
        dispatch(this.actions.setStepData(stepData));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setStepData(null));
  };

  public getInstitutionalIndicators = (followupId: string, subvCode?: string): AppThunk => (dispatch, getState) => {
    if(followupId){
      this.service
        .getInstitutionalIndicators(followupId, subvCode)
        .then((indData: any) => {
          dispatch(this.actions.setInstitutionalIndicators(indData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setInstitutionalIndicators(null));
  };

  public getNarrativeReport = (followupId: string): AppThunk => (dispatch, getState) => {
    if(followupId){
      this.service
        .getNarrativeReport(followupId)
        .then((indData: any) => {
          dispatch(this.actions.setNarrativeReport(indData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setNarrativeReport(null));
  };

  public getInfoByProject = (PPresCodProy: string): AppThunk => (dispatch, getState) => {
    if(PPresCodProy){
      this.service
        .getInfoByProject(PPresCodProy)
        .then((indData: any) => {
          dispatch(this.actions.setInfoByProject(indData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setInfoByProject(null));
  };

  public getInfoByCountry = (idCountry: string, isCountry: boolean, year: string): AppThunk => (dispatch, getState) => {
    if(idCountry){
      this.service
        .getInfoByCountry(idCountry, isCountry, year)
        .then((indData: any) => {
          dispatch(this.actions.setInfoByCountry(indData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }else dispatch(this.actions.setInfoByCountry(null));
  };

  public stateAppTourInd = (seen: boolean): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setSeenAppTourInd(seen));
    if(seen) dispatch(this.actions.setStepTourInd(0));
    else dispatch(this.actions.setStepTourInd(1));
  };

  public stateAppTourBen = (seen: boolean): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setSeenAppTourBen(seen));
    if(seen) dispatch(this.actions.setStepTourBen(0));
    else dispatch(this.actions.setStepTourBen(1));
  };

  public stateAppTourFin = (seen: boolean): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setSeenAppTourFin(seen));
    if(seen) dispatch(this.actions.setStepTourFin(0));
    else dispatch(this.actions.setStepTourFin(1));
  };

  public stateAppTourIN = (seen: boolean): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setSeenAppTourIN(seen));
    if(seen) dispatch(this.actions.setStepTourIN(0));
    else dispatch(this.actions.setStepTourIN(1));
  };

  public changeStepTourInd = (step: number): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setStepTourInd(step));
  };

  public changeStepTourBen = (step: number): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setStepTourBen(step));
  };

  public changeStepTourFin = (step: number): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setStepTourFin(step));
  };

  public changeStepTourIN = (step: number): AppThunk => (dispatch, getState) => {
    dispatch(this.actions.setStepTourIN(step));
  };

  public getMigrationData = (clear?: boolean): AppThunk => (dispatch, getState) => {
    if(clear){
      dispatch(this.actions.setMigrationData(null));
    }else{
      this.service
        .getMigrationData()
        .then((migData: any) => {
          dispatch(this.actions.setMigrationData(migData));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }
  };
}